module.exports = __webpack_public_path__ + "static/media/chubb-claims-hero.6d2d6512.png";